import { useRecoilState, useRecoilValue, useRecoilCallback } from 'recoil'
import {
  isBuilder,
  screen,
  screenOpen,
  editSectionId,
  editSectionWrapperId,
} from '@/store/builder/store'

// components
import Title from '@/components/onepager/sections/Title'
// import ShortTextDisplay from '@/components/onepager/sections/_shorttext/display'
import {
  RiArrowUpDownLine,
  RiArrowLeftRightLine,
  RiAddLine,
} from 'react-icons/ri'

function ShortText({ id, contentID, sectionData, wrapperId }) {
  const [getSreen, setScreen] = useRecoilState(screen)
  const [getScreenOpen, setScreenOpen] = useRecoilState(screenOpen)
  const [getEditSectionId, setEditSectionId] = useRecoilState(editSectionId)

  return (
    <div>
      <Title
        id={id}
        title={sectionData.title}
        prompt={sectionData.prompt}
        wrapperId={wrapperId}
      />

      <div className="boxBody">
        {sectionData.data.links.map((link, index) => (
          <a
            href={link.link}
            target="_blank"
            key={index}
            className="resourceCard  p-2 mb-2 rounded flex items-center cursor-pointer hover:bg-gray-50"
          >
            <div className="flex-grow w-1/2 md:w-3/4">
              <div className="pl-2">
                <div className="font-bold text-base md:text-lg">
                  {link.title}
                </div>
                <div className="text-xs py-1 truncate">{link.desc}</div>
                <div className="text-xs text-gray-500 truncate">
                  {link.link}
                </div>
              </div>
            </div>
            {link.image && (
              <div className="flex-shrink-0 w-1/2 md:w-1/4 pl-8">
                <img className="object-cover h-full w-full" src={link.image} />
              </div>
            )}
          </a>
        ))}

        {sectionData.data.links.length == 0 && (
          <div className="h-full">
            <div
              onClick={() => {
                setScreen('editsection')
                setScreenOpen(true)
                setEditSectionId(id)
              }}
              className=" cursor-pointer text-gray-400 bg-gray-50 hover:bg-blue-50 border-2 border-dashed border-gray-300 hover:text-blue-500 hover:border-blue-400 group rounded py-5 px-5 flex  items-center justify-center relative "
            >
              <div className="text-3xl ">
                <RiAddLine />
              </div>
              <h3 className="font-medium text-lg ">Add Link</h3>
              {/* <p className="font-medium text-xs opacity-75 ">Add Section</p> */}
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default ShortText
